export default __webpack_public_path__ + "static/media/icon_filter.500c8570.svg";